import { accountIdFormat } from "@redotech/redo-account-id";
import {
  consolidationGroupIdFormat,
  returnsCenterIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const createConsolidationGroup = {
  name: "createConsolidationGroup" as const,
  input: z.object({
    destinationCenterId: returnsCenterIdFormat.schema,
    merchantAccountIds: z.array(accountIdFormat.schema),
    name: z.string().trim().min(1),
    returnsCenterId: returnsCenterIdFormat.schema,
  }),
  output: z.object({ id: consolidationGroupIdFormat.schema }),
};
